import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";
export default function NotFound() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  useDocumentMeta("Seite nicht gefunden | CYPRUS PRIVÉ", "Die angeforderte Seite wurde nicht gefunden.", true);
  return <main className="paper-grain flex min-h-[70vh] items-center"><div className="container py-24 text-center"><p className="font-display text-8xl text-[#C4A46B]">404</p><h1 className="mt-4 display-md font-semibold">{tx("DIESE SEITE IST NICHT ÖFFENTLICH – ODER NICHT VORHANDEN.")}</h1><p className="mx-auto mt-5 max-w-xl leading-8 text-[#66615A]">{tx("Kehre zur Startseite zurück oder starte direkt deinen persönlichen Setup-Check.")}</p><div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row"><Button asChild variant="outline" className="rounded-none"><Link href="/"><ArrowLeft />{tx(" ZUR STARTSEITE")}</Link></Button><Button asChild className="rounded-none bg-[#A98950] text-white"><Link href="/setup-check">{tx("SETUP-CHECK STARTEN")}</Link></Button></div></div></main>;
}
